var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymceVue-Box"},[_c('div',{staticClass:"tinymceVue",style:({'min-height': '200px'})},[_c('div',{attrs:{"id":_vm.tinymceID}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }